import $ from 'jquery';

const $nav = $('nav');
const top = $nav.height() * 0.5;
const classesToAdd = 'shadow-lg bg-primary-dark-transparent';
const classesToRemove = 'py-lg-4';
const $window = $(window);

const scrollFn = function () {
	if ($window.scrollTop() >= top) {
		$nav.addClass(classesToAdd);
		// $nav.css({opacity: .9});
		$nav.removeClass(classesToRemove);
	} else {
		$nav.removeClass(classesToAdd);
		// $nav.css({opacity: 1});
		$nav.addClass(classesToRemove);
	}
};

$window.scroll(scrollFn);

scrollFn();
